import React, { createContext, useContext, useState } from 'react';
import { useBenefit } from './BenefitSelectedContext';
import { setCookie, getCookie, deleteCookie } from '../util/Cookie';

const UserContext = createContext(undefined);

let setUserGlobal = () => { };

export const UserProvider = ({ children }) => {
    const _init_ = getCookie("user_data");
    const [userData, setUserData] = useState(_init_ ? JSON.parse(_init_) : null);
    const { benefitSelected, setBenefitSelected } = useBenefit();

    const setUser = (userData) => {
        if (!benefitSelected && userData?.user?.beneficiosProdutos) {
            setBenefitSelected(userData.user.beneficiosProdutos[0].codigoBeneficio);
        }

        if (userData) {
            setCookie("user_data", JSON.stringify(userData), 1); // expira em 1 dia
        } else {
            deleteCookie("user_data"); // se passar null, remove
        }

        setUserData(userData);
        return userData;
    };

    setUserGlobal = setUserData;

    return (
        <UserContext.Provider value={{ userData, setUser }}>
            {children}
        </UserContext.Provider>
    );
};

export const useUserData = () => {
    const context = useContext(UserContext);
    if (!context) throw new Error('useUserData deve ser usado dentro de UserProvider');
    return context;
};

export const setGlobalUserData = (user) => {
    setUserGlobal(user);
};
